import { CLOSED_AT_OPTIONS, usePollOptionsState } from "../PollOptionsState";
import React from "react";
import { ChipButtonsListSection } from "./ChipButtonsList";

export function TimeLimitSection() {
    const { closedAt, setClosedAt } = usePollOptionsState();

    return (
        <ChipButtonsListSection
            sectionTitle="Wie lange soll die Umfrage laufen?"
            items={Object.entries(CLOSED_AT_OPTIONS).map(([key, value]) => ({
                label: key,
                isSelected: value === closedAt,
                onClick: () => {
                    setClosedAt(value);
                },
            }))}
        />
    );
}
